import { formatCurrency, formatProfitFactor } from '../../utils/formatters';

/**
 * 3x2 grid of trade statistics tiles.
 */
function StatTile({ value, label, color, bg, valueFontSize = '1.8rem' }) {
  return (
    <div className="stat-tile" style={{ background: bg }}>
      <div className="stat-tile-value" style={{ color, fontSize: valueFontSize }}>{value}</div>
      <div className="stat-tile-label">{label}</div>
    </div>
  );
}

function TradeStatisticsCard({ tradeStats }) {
  const profitFactorValue = formatProfitFactor(tradeStats?.profit_factor);

  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Trade Statistics</span>
      </div>
      <div className="card-body">
        {tradeStats ? (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '10px',
              height: '100%',
            }}
          >
            {/* Row 1: Total Trades / Winners / Losers */}
            <StatTile value={tradeStats.total_trades} label="Total Trades" color="#3b82f6" bg="rgba(59, 130, 246, 0.1)" />
            <StatTile value={tradeStats.winners || 0} label="Winners" color="#22c55e" bg="rgba(34, 197, 94, 0.1)" />
            <StatTile value={tradeStats.losers || 0} label="Losers" color="#ef4444" bg="rgba(239, 68, 68, 0.1)" />
            {/* Row 2: Profit Factor / Realized P&L / Win Rate (under Losers) */}
            <StatTile
              value={profitFactorValue}
              label="Profit Factor"
              color="#f59e0b"
              bg="rgba(245, 158, 11, 0.1)"
            />
            <StatTile
              value={formatCurrency(tradeStats.total_realized_pnl_gbp)}
              label="Realized P&L"
              color={tradeStats.total_realized_pnl_gbp >= 0 ? '#22c55e' : '#ef4444'}
              bg={tradeStats.total_realized_pnl_gbp >= 0 ? 'rgba(34, 197, 94, 0.1)' : 'rgba(239, 68, 68, 0.1)'}
              valueFontSize="1.5rem"
            />
            <StatTile value={`${Math.round(tradeStats.win_rate_pct || 0)}%`} label="Win Rate" color="#a855f7" bg="rgba(168, 85, 247, 0.1)" />
          </div>
        ) : (
          <p className="text-muted">No trade statistics available</p>
        )}
      </div>
    </div>
  );
}

export default TradeStatisticsCard;
